module.exports = __webpack_public_path__ + "static/media/Reich.a72a3229.png";